// Sposób wpłaty przyjętej na miejscu (POST /api/payments/record-offline): gotówka, przelew i od F.10
// karta z terminala płatniczego wypożyczalni (bez Stripe). LUSTRO Login/backend/lib/metodaWplaty.js.
// Wpłaty online mają provider 'stripe' i metodę ze Stripe, tu ich nie ma.

export const METODY_NA_MIEJSCU = ['cash', 'transfer', 'card'];

export const jestMetodaNaMiejscu = (metoda) => METODY_NA_MIEJSCU.includes(metoda);

/** Nazwa metody do listy i rejestru („Gotówka”, „Przelew”, „Karta (terminal)”) albo null. */
export function nazwaMetody(metoda, t) {
  if (metoda === 'cash') return t('payments.methodCash');
  if (metoda === 'transfer') return t('payments.methodTransfer');
  if (metoda === 'card') return t('payments.methodCard');
  return null;
}

/** Metoda w zdaniu („Zapisać zaliczkę gotówką?”, „kartą (terminal)”). Nieznana = gotówka, jak dotąd. */
export function slowoMetody(metoda, t) {
  if (metoda === 'transfer') return t('reservationForm.offline.transferWord');
  if (metoda === 'card') return t('reservationForm.offline.cardWord');
  return t('reservationForm.offline.cashWord');
}
